module.exports = __webpack_public_path__ + "static/media/gvl-sky.174a9d34.png";